export enum SearchHistoryType {
  DATA_ROOM,
  VIRTUAL_DATA_ROOM,
}
